var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChild = function SvgIconChild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.4998,
    cy: 7.64706,
    rx: 2.7,
    ry: 2.64706
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.2354C7 12.7501 9.01472 10.7354 11.5 10.7354C13.9853 10.7354 16 12.7501 16 15.2354V19.5589H7V15.2354Z"
  })));
};
export default SvgIconChild;